// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ExclusiveSaleBanner-module__banner{margin-bottom:3rem}", "",{"version":3,"sources":["webpack://src/components/customer/account/ExclusiveSaleBanner.module.scss"],"names":[],"mappings":"AAAA,oCACE,kBAAA","sourcesContent":[".banner {\n  margin-bottom: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": "ExclusiveSaleBanner-module__banner"
};
export default ___CSS_LOADER_EXPORT___;
